import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import InputField from '../../shared/InputField';
import { checkButtonDisabled } from '../../../utils/forms';

const FORM_ID = 'configureInstallForm';

export default class ConfigureEloquaInstallForm extends React.Component {
  static propTypes = {
    authUrl: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateConfigFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.updateConfig = this.updateConfig.bind(this);
  }

  updateConfig = evt => {
    const { updateConfigFunction } = this.props;
    updateConfigFunction(evt);
  };

  render() {
    const { authUrl, invalid, handleSubmit, submitting } = this.props;

    return (
      <Form
        id={FORM_ID}
        className="padded-form small-space"
        style={{ paddingTop: '0' }}
        onSubmit={handleSubmit(this.updateConfig)}
      >
        <fieldset style={{ marginBottom: '1rem' }}>
          <div className="form-group no-inner-margin">
            <div className="row">
              <div className="col-xs-12">
                <Field
                  name="description"
                  type="text"
                  component={InputField}
                  label="Description"
                  maxLength="255"
                  autoFocus
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div>
                  <label htmlFor="authUrl" className="form-control-label">
                    Auth URL
                  </label>
                  <a id="authUrl" href={authUrl}>
                    {authUrl}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <p className="pull-right">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkButtonDisabled(invalid, submitting)}
          >
            Save Config
          </button>
        </p>
      </Form>
    );
  }
}
